import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';

export default {
  title: 'Viewpoints',
  attributeName: 'viewpoints',
  validationUrl:'live',
  hiddenJsonComponent:true,
  fields: [
    {
      attributeName: 'uniqueId',
      label: 'UNIQUEID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'parentUID',
      label: 'PARENTUID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'positionX',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Position X',
      required: true,
      default:"0",
      helpText: 'Set the pos x.',
      errorText: '',
      autoComplete:false
    },
    {
      attributeName: 'positionY',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Position Y',
      required: true,
      default:"0",
      helpText: 'Set the pos y.',
      errorText: '',
    },
    {
      attributeName: 'positionZ',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Position Z',
      required: true,
      default:"0",
      helpText: 'Set the pos z.',
      errorText: '',
    },
    {
      attributeName: 'rotationX',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Rotation X',
      required: true,
      default:"0",
      helpText: 'Set the rot x.',
      errorText: '',
    },
    {
      attributeName: 'rotationY',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Rotation Y',
      required: true,
      default:"0",
      helpText: 'Set the rot Y.',
      errorText: '',
    },
    {
      attributeName: 'rotationZ',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Rotation Z',
      required: true,
      default:"0",
      helpText: 'Set the rot z.',
      errorText: '',
    },
    {
      attributeName: 'scale',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Scale',
      required: true,
      default:"1",
      helpText: 'Set the cam scale.',
      errorText: '',
    },
  ]
};
